<template>
  <div class="pageWrapper" ref="pageWrapper">
    <div v-if="showBlockMessage" class="container" style="margin-top: 30px">
      <info-bar
        :with-close="false"
        color="#ff6e00"
        icon="warning"
        layout="light"
        message="Twoja sesja punchout wygasła. Zaloguj się ponownie aby kontynuować zakupy.Jeśli problem będzie się powtarzał upewnij się, że Twoja przeglądarka zezwala na ciasteczka dla strony Ofix.pl"
      />
    </div>
    <div v-show="!showBlockMessage">
      <LazyHydrate when-visible>
        <MobileMenu :menu-items="computedMenuItems" menu-name="category" />
      </LazyHydrate>
      <LazyHydrate when-visible>
        <HeaderSearch class="headerSearch--mobile" mobile />
      </LazyHydrate>
      <InfoHeader :class="[{ 'infoHeader--showLoader': showLoader }]" ref="infoHeader" />
      <PageHeader
        :class="[
          [headerPrefix ? `header--${headerPrefix}` : ''],
          { 'pageHeader--showLoader': showLoader },
        ]"
        :other-accounts="otherAccounts"
        ref="header"
        :current-company="currentCompany"
        @switch-account="checkAccountSwitch"
      />
      <nuxt
        :class="[
          'pageWrapper__inner',
          {
            'pageWrapper__inner--hideMobileSearch': isInitialMobileHideSearch,
          },
          {
            'pageWrapper__inner--darkLayer': showPageDarkLayer,
          },
        ]"
        class="pageWrapper__inner"
        ref="page"
      />
      <LazyHydrate when-visible>
        <MainFooter />
      </LazyHydrate>
      <Modal />
      <LightBox />
      <ScrollTop :visible="scrollTopButtonVisible" />
      <AgeInformationPopup v-if="ageInformationPopup.show" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { throttle } from 'lodash';
import LazyHydrate from 'vue-lazy-hydration';
import Modal from '~/components/Modal/ModalStack';
import InfoHeader from '@/components/InfoHeader';
import PageHeader from '@/components/PageHeader';
import ScrollTop from '@/components/ScrollTop';
import listMixin from '~/mixins/list';
import AgeInformationPopup from '@/components/AgeInformationPopup';
import InfoBar from '@/components/InfoBar.vue';

export default {
  name: 'DefaultView',
  components: {
    InfoBar,
    AgeInformationPopup,
    ScrollTop,
    LazyHydrate,
    Modal,
    InfoHeader,
    PageHeader,
    LightBox: () => import('~/components/LightBox'),
    HeaderSearch: () => import('~/components/HeaderSearch'),
    MobileMenu: () => import('~/components/MobileMenu'),
    MainFooter: () => import('~/containers/MainFooter'),
  },
  mixins: [listMixin],
  data() {
    return {
      prevScrollPos: 0,
      scrollTopButtonVisible: false,
      showBlockMessage: false,
    };
  },
  head() {
    return this.$nuxtI18nHead({ addSeoAttributes: true });
  },
  computed: {
    ...mapState('layout', [
      'headerPrefix',
      'isInitialMobileHideSearch',
      'isScrollDownMobileHide',
      'mobileCategoryMenuData',
      'showLoader',
      'showPageDarkLayer',
      'showPageDarkLayer',
      'ageInformationPopup',
    ]),
    ...mapState('auth', ['otherAccounts', 'acl', 'currentCompany']),
    ...mapState('settings', ['businessVariables']),
    computedMenuItems() {
      const mapCategorySlug = category => {
        return {
          ...category,
          slug: this.localePath({ name: 'category-slug', params: { slug: category.slug } }),
          children: category.children ? category.children.map(item => mapCategorySlug(item)) : [],
        };
      };

      return this.mobileCategoryMenuData.map(item => mapCategorySlug(item));
    },
  },
  watch: {
    showLoader(val) {
      const pageHeader = this.$refs.header.$el;
      if (val) {
        const infoHeader = this.$refs.infoHeader.$el;
        if (document.documentElement.scrollTop < infoHeader.clientHeight) {
          pageHeader.style.top = `${infoHeader.clientHeight + 1}px`;
        } else {
          pageHeader.style.top = '0px';
        }
      } else {
        pageHeader.style.top = '';
      }
    },
  },

  mounted() {
    this.$auth.setAxiosHeader(this.$cookies.get('auth'));
    if (this.acl && this.acl.canSwitchToOtherAccounts) {
      this.fetchOtherAccounts();
    }
    this.getShoppingLists();

    this.fetchAutocompleteCategoryMenuData();
    this.fetchMobileCategoryMenuData();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    window.addEventListener('scroll', this.setScrollTopButtonVisibility);
    this.handleScroll();
    this.checkPunchOutMode();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
    window.removeEventListener('scroll', this.setScrollTopButtonVisibility);
  },
  methods: {
    ...mapActions({
      fetchMobileCategoryMenuData: 'layout/fetchMobileCategoryMenuData',
      fetchAutocompleteCategoryMenuData: 'layout/fetchAutocompleteCategoryMenuData',
      fetchOtherAccounts: 'auth/fetchOtherAccounts',
      checkAccountSwitch: 'auth/checkAccountSwitch',
    }),
    ...mapMutations({
      setCurrentCompany: 'auth/setCurrentCompany',
    }),
    checkPunchOutMode() {
      const domain = process.client ? window.location.hostname : '';
      this.showBlockMessage =
        domain === 'punchout.ofix.pl' && !this.businessVariables?.isPunchOutMode;
    },
    handleScroll() {
      if (!this.$refs.infoHeader || !this.$refs.header) return;
      const minScroll = this.$refs.infoHeader.$el.offsetHeight;
      if (document.documentElement.scrollTop > minScroll - 1) {
        this.$refs.header.$el.addClass('pageHeader--fixed');
        this.$refs.pageWrapper.addClass('pageWrapper--fixed');
      } else {
        this.$refs.header.$el.removeClass('pageHeader--fixed');
        this.$refs.pageWrapper.removeClass('pageWrapper--fixed');
      }

      if (this.isScrollDownMobileHide && window.innerWidth <= 768) {
        this.bringMenu();
      }
    },
    bringMenu() {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos < 130) {
        this.$refs.header.$el.removeClass('pageHeader--mobileHide');
      } else if (this.prevScrollPos > currentScrollPos) {
        this.$refs.header.$el.removeClass('pageHeader--mobileHide');
      } else {
        this.$refs.header.$el.addClass('pageHeader--mobileHide');
      }
      this.prevScrollPos = currentScrollPos;
    },
    // eslint-disable-next-line space-before-function-paren
    setScrollTopButtonVisibility: throttle(function (e) {
      if (!this.$route.name.includes('index')) {
        if (typeof e.target !== 'undefined' && typeof e.target.documentElement !== 'undefined') {
          const offset = e.target.documentElement.scrollTop;
          this.scrollTopButtonVisible = offset > window.innerHeight;
        }
      }
    }, 250),
  },
};
</script>

<style lang="scss">
.pageWrapper {
  $root: &;

  &--fixed {
    #{$root}__inner {
      @include rwd('tablet') {
        padding-top: 5.9rem;
      }

      &--hideMobileSearch {
        @include rwd('tablet') {
          padding-top: 5.9rem;
        }
      }
    }
  }

  &__inner {
    &--darkLayer::after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.2;
      background: #000;
    }
  }
}
</style>
